const hook = {
  /**
  * 給所有查询添加条件
  * @date: 2020/3/9
  */
  beforeFetch ({ where }) {
    // where.isDeleted = false
  }
}
export default hook
